import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import lossesIcon from "../../../../../assets/new-product-detail-cats/header-icons/manufacturing-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getLosses35Totals } from "../../../../../apis/Product/LossesFlow35Api";

const Losses35Icon = () => (
  <img src={lossesIcon} alt="Losses 35 Icon" width={76} height={76} />
);

const Losses35Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalLossesItem, setTotalLossesItem] = useState(null);

  useEffect(() => {
    if (productId) {
      getLosses35Totals({
        productId,
        setTotals: setTotalLossesItem,
      });
    }
  }, [productId]);

  return (
    <CategoryComponent
      show={show}
      className={`losses-35-category ${className || ""}`}
      leftBoxProps={{
        icon: <Losses35Icon />,
        title: t("LOSSES") || "Losses",
        description:
          t("LOSSES_35_DESC") ||
          "This is where you record any losses in this category relating to water, packaging and product components. In the 'Product and Manufacturing' section, you could record, for example, that you glue something and some of the weight is lost due to off-gassing during the drying phase. Losses during transport can be also recorded here.",
        productId: productId,
        isSystemBoundary: false,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_35") || "Total for Flow 35",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalLossesItem?.impact_totals || null,
        lastUpdated: totalLossesItem?.updated_at
          ? formatDate(totalLossesItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default Losses35Header;

